import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from "react-router-dom";
import './index.css'
import App from './App.jsx'
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './authConfig.js';

const msalInstance = new PublicClientApplication(msalConfig);

// This should run every time your app loads
msalInstance.handleRedirectPromise()
    .then((response) => {
        if (response !== null) {
            // User just returned from a successful login
            console.log("Login successful:", response.account);
        } else {
            // No redirect occurred; check if a user is already signed in
            const currentAccounts = msalInstance.getAllAccounts();
            if (currentAccounts.length > 0) {
                console.log("User already signed in:", currentAccounts[0]);
            }
        }
    })
    .catch((error) => {
        console.error("Login error:", error);
    });

// DMB - original code
//// Default to using the first account if no account is active on page load
//if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//    // Account selection logic is app dependent. Adjust as needed for different use cases.
//    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
//}

//// Optional - This will update account state if a user signs in from another tab or window
//msalInstance.enableAccountStorageEvents();

//// Listen for sign-in event and set active account
//msalInstance.addEventCallback((event) => {
//    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
//        const account = event.payload.account;
//        msalInstance.setActiveAccount(account);
//    }
//});

createRoot(document.getElementById('root')).render(
    <StrictMode>
  <BrowserRouter>
            <App instance={msalInstance} />
        </BrowserRouter>
  </StrictMode>
)

